import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 21px 7px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .sensorsHeader {
    width: 100%;
    padding-left: 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .headerTitle {
    margin: 0;
    font-size: 14px;
    color: #6c757d;
    font-weight: 600;
    line-height: 16.71px;
  }

  .scroll {
    width: 100%;
    height: 100%;
    align-items: flex-start;
    overflow-y: scroll;
  }

  .dropDown {
    width: 16px;
    height: 16px;
    padding: 0;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 0;
    background-color: transparent;
  }

  .statusSmallTag {
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }

  .openCloseButton {
    width: 100%;
    height: 36px;
    margin-top: 8px;
    border-radius: 4px;
    font-size: 16px;
    border: none;
    text-align: center;
    color: #ffffff;
    background-color: #007bff;
  }

  .openCloseButton:disabled {
    background-color: #007bff50;
  }

  .battery {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
  }

  .celsius {
    margin: 0;
    line-height: 0;
    font-size: 24px;
    font-weight: 600;
    color: #6c757d;
  }

  .sensorIcon {
    margin-top: 4px;
    width: 20px;
    height: auto;
    margin-right: 8px;
  }
`;

export const CardSensors = styled.div`
  width: 100%;
  margin-bottom: 16px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  /* border: 1px solid #cdcdcd; */
  background: "#F9F9F9";

  .titleSensorsCard {
    margin: 0;
  }

  .statusSensors {
    width: 100%;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .status {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cardFooter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
  }

  .statusDate {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    p {
      font-size: 14px;
      font-weight: 400;
      margin: 0;
    }
  }

  .pStatusDate {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }

  .openOrClosed {
    width: 132px;
    height: 32px;
    padding: 4px 8px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-radius: 23px;
    border: 1px solid #ced4da;
    background-color: #f9f9f9;

    p {
      margin: 0;
      font-size: 16px;
      font-weight: 400;
      color: #6c757d;
    }
  }
`;

export const SmallTag = styled.div`
  width: 54px;
  height: 21px;
  margin: 0;
  padding: 0 4px;
  align-items: center;
  display: flex;
  border-radius: 21px;
  background-color: #f2f2f2;

  .statusSmallTag {
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }

  p {
    font-family: "Montserrat";
    font-size: 10px;
    font-weight: 500;
    margin: 0;
    margin-left: 3px;
    color: "#4F4F4F";
  }
`;

export const LargerTag = styled.div`
  width: 132px;
  height: 32px;
  display: flex;
  border-radius: 23px;
  border: 1px solid #ced4da;
  background-color: #f9f9f9;
`;

export const SensorsNumber = styled.div`
  width: 28px;
  height: 20px;
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 29px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #007bff;
  color: #f8f9fa;
`;

export const CardActuators = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px 0px 8px 0px;
  border-radius: 5px;
  border: 1px solid #cdcdcd;
`;
